import { Text, VStack } from 'ui_2';

export const LoadingMessage = ({ message }: { message: string }) => {
  return (
    <VStack className='flex min-h-[100dvh] items-center justify-center'>
      <VStack className='max-w-4/5 rounded-[10px] border border-aqua bg-[#13252c] p-4 text-center'>
        <Text color='aqua' family='space'>
          {message}
        </Text>
      </VStack>
    </VStack>
  );
};
